import { render } from "./cu-aside.vue?vue&type=template&id=4fb53f19&scoped=true"
import script from "./cu-aside.vue?vue&type=script&lang=js"
export * from "./cu-aside.vue?vue&type=script&lang=js"

import "./cu-aside.vue?vue&type=style&index=0&id=4fb53f19&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb53f19"]])

export default __exports__